import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Swiper from 'swiper/bundle'
gsap.registerPlugin(DrawSVGPlugin)

/**
 * CTA Banner component.
 * @author Dayne Coulson-Hoffacker
 */
export default class CardCarousel {
  /**
   * Constructs a new CardCarousel component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    this.cards = this.element.querySelector('.cards')

    var slider = new Swiper(this.cards, {
      slidesPerView: 1,
      spaceBetween: 20,
      //loop: true,
      /*
      autoplay: {
        delay: 2500,
        disableOnInteraction: true
      },
      */
      autoplay: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 68
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })

    ScrollTrigger.create({
      trigger: this.element,
      start: 'top bottom',
      markers: false,
      scroller: 'body',
      onEnter: () => {
        slider.autoplay.start()
      }
    })


    var cardCarouselTL = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.element.querySelectorAll('.card').forEach(card => {
          gsap.to(card, { duration: 1, autoAlpha: 1, ease: 'power2' })
        })
      }
    })

    cardCarouselTL.to(this.element, { duration: 1, autoAlpha: 1, ease: 'power2' })
    /*
    ctaBannerTL.to(this.video, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.mainHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.subHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')
    */

    cardCarouselTL.play()
  }
}



// WEBPACK FOOTER //
// ./components/section/card-carousel/index.js